var ArchieTokenExpiredModal, ArchieTokenExpiredModalView, ReactComponent, View,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

View = require('base/views/view');

ReactComponent = require('base/lib/traits/react_component');

ArchieTokenExpiredModal = require('components/archie/archie_token_expired_modal');

module.exports = ArchieTokenExpiredModalView = (function(_super) {
  __extends(ArchieTokenExpiredModalView, _super);

  function ArchieTokenExpiredModalView() {
    return ArchieTokenExpiredModalView.__super__.constructor.apply(this, arguments);
  }

  ArchieTokenExpiredModalView.prototype.initialize = function() {
    ArchieTokenExpiredModalView.__super__.initialize.apply(this, arguments);
    this.enable(ReactComponent);
    return this.renderSimpleComponent(ArchieTokenExpiredModal);
  };

  ArchieTokenExpiredModalView.prototype.dispose = function() {
    this.unmountComponent();
    return ArchieTokenExpiredModalView.__super__.dispose.apply(this, arguments);
  };

  return ArchieTokenExpiredModalView;

})(View);
